import axios from "axios";
import { apiConfig } from "../../config";
const prefixUrl = apiConfig.prefix;
const hostUrl = window.location.protocol + '//' + window.location.host;
class ApiInstance {
    axios;
    constructor() {
        this.axios = axios.create({
            baseURL: hostUrl + prefixUrl,
            timeout: 50000,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "PUT, DELETE, GET, OPTIONS, POST",
                "Access-Control-Allow-Headers": "*",
                'Content-Type': 'application/json'
            },
        });
    }
    async get(endpoint, options = {}, normalizeResponseCb) {
        try {
            const response = await this.axios.get(endpoint, options);
            if (normalizeResponseCb) {
                return normalizeResponseCb(response);
            }
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
    async getProgress(endpoint, options = {}, progressCallback, completeCallback) {
        try {
            options.onDownloadProgress = (progressEvent) => {
                if (progressEvent.download) {
                    progressCallback(100);
                    return;
                }
                const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total ?? 1));
                progressCallback(percent);
            };
            const response = await this.axios.get(endpoint, options);
            completeCallback(response.data);
            return response.data;
        }
        catch (error) {
            completeCallback(undefined);
            return;
        }
    }
    async post(endpoint, data, options = {}, normalizeResponseCb) {
        try {
            const response = await this.axios.post(endpoint, data, options);
            if (normalizeResponseCb) {
                return normalizeResponseCb(response);
            }
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
    async put(endpoint, data, options = {}, normalizeResponseCb) {
        try {
            const response = await this.axios.put(endpoint, data, options);
            if (normalizeResponseCb) {
                return normalizeResponseCb(response);
            }
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
    async patch(endpoint, data, options = {}, normalizeResponseCb) {
        try {
            const response = await this.axios.put(endpoint, data, options);
            if (normalizeResponseCb) {
                return normalizeResponseCb(response);
            }
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
    async delete(endpoint, options = {}, normalizeResponseCb) {
        try {
            const response = await this.axios.delete(endpoint, options);
            if (normalizeResponseCb) {
                return normalizeResponseCb(response);
            }
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
    requestFromConfig(config) {
        return this.axios(config);
    }
    addOnAuthenticationInterceptors(onAuthentication) {
        this.axios.interceptors.request.use(onAuthentication);
    }
    addOnExpiredInterceptors(onExpired) {
        this.axios.interceptors.response.use(null, onExpired);
    }
}
export const apiInstance = new ApiInstance();
